import { readFileAsBuffer } from '@/utils/file';
import { Fits, Hdu } from "@hscmap/fits";
import MakeTiles from 'worker-loader!./makeTiles'
import { IMakeTileRequest, IMakeTileResponse } from './makeTiles';
import { assert } from '@/utils/error';
import { Vue, Component } from "vue-property-decorator";
import { defaultTone } from './tone';

@Component
export class FitsImage extends Vue {
  static id = 0

  name!: string
  tiles?: { [path: string]: ArrayBuffer }
  id!: number
  hdu!: Hdu
  show = true
  toneWindow = false
  tone = defaultTone()

  private static make(name: string, hdu: Hdu) {
    return new FitsImage({
      data: {
        name,
        hdu: Object.freeze(hdu),
        id: ++FitsImage.id,
      },
    })
  }

  static async fromArrayBuffer(name: string, buffer: ArrayBuffer, hduIndex = 1) {
    const fits = await Fits.decode(buffer)
    const hdu = fits[hduIndex]
    const fitsImage = FitsImage.make(name, hdu)
    await fitsImage.makeTiles()
    return fitsImage
  }

  static async fromFile(file: File, hduIndex = 1) {
    const buffer = await readFileAsBuffer(file)
    return await this.fromArrayBuffer(file.name, buffer, hduIndex)
  }

  async makeTiles() {
    const { type, tiles } = await new Promise((resolve, reject) => {
      const makeTiles = new MakeTiles()
      makeTiles.addEventListener('message', (e) => {
        const res: IMakeTileResponse = e.data
        resolve(res)
      })
      const req: IMakeTileRequest = {
        header: this.hdu.header,
        ab: this.hdu.data,
      }
      makeTiles.postMessage(req, [this.hdu.data])
    })

    assert(type === 'float32')
    this.tiles = Object.freeze(tiles)
  }

  resetTone() {
    const tone = defaultTone()
    delete tone.type
    Object.assign(this.tone, tone)
  }
}
